import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const routes = [
  {
    path: "/cpanel/banners",
    name: "بنر",
    icon: <FontAwesomeIcon icon={"images"} className="text-secondary" />,
    
  },
  {
    path: "/cpanel/sidebar",
    name: "کنترل منو سایدبار",
    icon: <FontAwesomeIcon icon={"hamburger"} className="text-secondary" />,
  },
  {
    path: "/cpanel/pagemaker",
    name: "صفحه ساز",
    icon: <FontAwesomeIcon icon={"marker"} className="text-secondary" />,
  },
  {
    path: "/cpanel/features",
    name: "ویژگی ها",
    icon: <FontAwesomeIcon icon={"icons"} className="text-secondary" />,
  },
  {
    path: "/cpanel/shopscategory",
    name: "دسته بندی محصولات ",
    icon: <FontAwesomeIcon icon={"icons"} className="text-secondary" />,
  },
  {
    path: "/cpanel/products",
    name: "محصولات",
    icon: <FontAwesomeIcon icon={"icons"} className="text-secondary" />,
  },
  {
    path: "/cpanel/video",
    name: "ویدئو",
    icon: <FontAwesomeIcon icon={"video"} className="text-secondary" />,
  },
  {
    path: "/cpanel/users",
    name: "امور مشتریان",
    icon: <FontAwesomeIcon icon={"user"} className="text-secondary" />,
  },

  {
    path: "/cpanel/shop",
    name: "فروشگاه ها",
    icon: <FontAwesomeIcon icon={"shop"} className="text-secondary" />,
  },
  {
    path: "/cpanel/insurance",
    name: "بیمه نامه",
    icon: <FontAwesomeIcon icon={"heart-pulse"} className="text-secondary" />,
  },
  {
    path: "/cpanel/management",
    name: "مدیریت پرسنل",
    icon: <FontAwesomeIcon icon={"lock"} className="text-secondary" />,
  },
  {
    path: "/cpanel/coinfund",
    name: "صندوق تاب30",
    icon: <FontAwesomeIcon icon={"cash-register"} className="text-secondary" />,
  },
  {
    path: "/cpanel/fund",
    name: "صندوق ریالی",
    icon: <FontAwesomeIcon icon={"cash-register"} className="text-secondary" />,
  },
  {
    path: "/cpanel/sell",
    name: "فروش ها",
    icon: <FontAwesomeIcon icon={"store"} className="text-secondary" />,
  },
  {
    path: "/cpanel/pay",
    name: "پرداخت ها",
    icon: <FontAwesomeIcon icon={"store"} className="text-secondary" />,
  },
  {
    path: "/cpanel/shopcells",
    name: "فروش فروشگاه ها",
    icon: <FontAwesomeIcon icon={"cart-shopping"} className="text-secondary" />,
  },
  {
    path: "/cpanel/shopbuy",
    name: "دریافت فروشگاه ها",
    icon: <FontAwesomeIcon icon={"money-bills"} className="text-secondary" />,
  },
];
